// context/ProductContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import Axios from "axios";

const ProductContext = createContext();

export const useProductContext = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // 📦 جلب الاصناف
  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/product/getProducts.php`
      );
      if (res.data.status === "success") {
        setProducts(res.data.products);
      }
    } catch (err) {
      console.error("خطأ في جلب الاصناف:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔍 البحث عن منتج بالباركود
  const getProductByBarcode = async (barcode) => {
    try {
      console.log("📡 إرسال طلب API للباركود:", barcode);
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/product/getProductByBarcode.php`,
        {
          params: { barcode },
          withCredentials: true,
        }
      );
      console.log("📥 استجابة API:", res.data);

      if (res.data.status === "success") {
        console.log("✅ المنتج من API:", res.data.product);
        return res.data.product;
      }
      console.log("⚠️ المنتج غير موجود في قاعدة البيانات");
      return null;
    } catch (err) {
      console.error("❌ خطأ في API البحث عن المنتج:", err);
      return null;
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        loading,
        fetchProducts,
        getProductByBarcode,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
